import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { allArticles } from "@/mocks/articles";

export default function FooterSection() {
  const footerCategories = categories.slice(0, 7);
  const footerArticles = allArticles.slice(0, 6);

  const footerFaq = [
    { label: "Czy USFansSpreadsheet jest darmowy?", slug: "usfansspreadsheet-kompletny-przewodnik" },
    { label: "Jak działa USFansSpreadsheet?", slug: "usfansspreadsheet-kompletny-przewodnik" },
    { label: "Czy dane są bezpieczne?", slug: "czy-usfansspreadsheet-jest-bezpieczny" },
    { label: "Alternatywy", slug: "usfansspreadsheet-alternatywy-rynek" },
  ];

  return (
    <footer className="relative w-full bg-foreground-950 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-12 md:mb-16">
          <div className="max-w-xs">
            <div className="flex items-center gap-3 mb-4">
              <span className="font-heading text-xl md:text-2xl font-semibold text-white tracking-tight">
                USFansSpreadsheet
              </span>
            </div>
            <p className="text-sm text-white/50 leading-relaxed">
              Kompletny przewodnik, porównania i najlepsze rozwiązania USFansSpreadsheet w 2026 roku.
            </p>
          </div>

          <p className="text-sm text-white/40 max-w-xs hidden md:block">
            Elegancja / Precyzja / Styl
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12 md:mb-16">
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Kategorie</h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="cursor-pointer text-sm text-white/50 hover:text-white/80 transition-colors"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Artykuły SEO</h4>
            <ul className="space-y-2.5">
              {footerArticles.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/artykul/${item.slug}`}
                    className="cursor-pointer text-sm text-white/50 hover:text-white/80 transition-colors"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">FAQ</h4>
            <ul className="space-y-2.5">
              {footerFaq.map((item, idx) => (
                <li key={idx}>
                  <Link
                    to={`/artykul/${item.slug}`}
                    className="cursor-pointer text-sm text-white/50 hover:text-white/80 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Kontakt</h4>
            <div className="space-y-3">
              <p className="font-heading text-lg text-white/60">
                &copy; USFansSpreadsheet 2026
              </p>
              <p className="text-xs text-white/40">
                Wszelkie prawa zastrzeżone.
              </p>
              <div className="flex items-center gap-4 pt-2">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="cursor-pointer text-white/40 hover:text-white/70 transition-colors">
                  <i className="ri-twitter-x-line w-5 h-5 flex items-center justify-center"></i>
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="cursor-pointer text-white/40 hover:text-white/70 transition-colors">
                  <i className="ri-facebook-line w-5 h-5 flex items-center justify-center"></i>
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="cursor-pointer text-white/40 hover:text-white/70 transition-colors">
                  <i className="ri-instagram-line w-5 h-5 flex items-center justify-center"></i>
                </a>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="cursor-pointer text-white/40 hover:text-white/70 transition-colors">
                  <i className="ri-linkedin-line w-5 h-5 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 items-start border-t border-white/10 pt-8">
          <div className="w-full sm:w-48 h-32 rounded-2xl overflow-hidden bg-white/5">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20lifestyle%20scene%20with%20warm%20ambient%20lighting%2C%20clean%20modern%20interior%20corner%20with%20trailing%20plants%20and%20soft%20textiles%2C%20cream%20beige%20sage%20green%20palette%2C%20sophisticated%20boutique%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20no%20text%20no%20logos%2C%20editorial%20quality&width=400&height=300&seq=footer-img-v2&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <div className="flex-1 flex items-center">
            <p className="font-heading text-xl md:text-2xl text-white/30 leading-relaxed">
              Elegancja / Precyzja / Styl
            </p>
          </div>

          <div className="w-full sm:w-auto">
            <p className="text-sm text-white/50 mb-3">
              Zapisz się do newslettera
            </p>
            <p className="text-xs text-white/30 mb-4">
              Otrzymuj najnowsze porównania i poradniki.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Twój email"
                className="flex-1 px-4 py-2.5 bg-white/10 border border-white/10 rounded-full text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-white/30"
              />
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="honeypot-field"
              />
              <button className="whitespace-nowrap cursor-pointer px-5 py-2.5 bg-accent-600 text-white rounded-full text-sm font-medium hover:bg-accent-700 transition-colors flex items-center gap-1.5">
                Zapisz się
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}